/* @flow */
import React, {PureComponent} from 'react';
import {injectIntl, FormattedMessage} from 'react-intl';
import SearchReviews from '../SearchReviews/SearchReviews';
import {MoreOrLess} from '@homeaway/react-collapse';

import type {SearchReview as SearchReviewShape} from '../../queries/searchQuery';

import './SeoContent.less';

type Props = {
    searchReviewsHeadline: string,
    searchReviews: SearchReviewShape[]
};

export class SeoContent extends PureComponent<Props> {
    render() {
        const {searchReviewsHeadline, searchReviews} = this.props;
        return (
            <div className={'SeoContent'} data-wdio={'SeoContent'}>
                <MoreOrLess
                    id="SeoContent__more-or-less"
                    lines={6}
                    lessText={
                        <FormattedMessage
                            defaultMessage="Show less"
                            id="showLessLabel"
                        />
                    }
                    moreText={
                        <FormattedMessage
                            defaultMessage="Show more"
                            id="showMoreLabel"
                        />
                    }
                >
                    <div className={'SeoContent__search-reviews-section'}>
                        <h4>{searchReviewsHeadline}</h4>
                        <SearchReviews reviews={searchReviews} />
                    </div>
                </MoreOrLess>
            </div>
        );
    }
}

export default injectIntl(SeoContent);
